<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        rowKey="id"
        :columns="columns"
        :row-selection="{ onChange: onSelectChange }"
        v-model:search="searchFrom"
        @fetch="fetch"
        ref="tableRef"
        tableId="lbuCouponsAuditRecord"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="审核状态">
              <a-radio-group
                v-model:value="searchFrom.reviewStatus"
                optionType="button"
                :options="statusEnum"
                @change="handleQueryChange()"
              />
            </dc-form-item>
            <dc-form-item name="customerName" label="客户名称">
              <a-input v-model:value="searchFrom.customerName" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="审核人">
              <UserSelect permission v-model:value="searchFrom.reviewer" allowClear />
            </dc-form-item>
            <dc-form-item label="审核时间">
              <cos-range-picker
                v-model:startTime="searchFrom.reviewStartTime"
                v-model:endTime="searchFrom.reviewEndTime"
              />
            </dc-form-item>
            <dc-form-item label="申请人">
              <UserSelect permission v-model:value="searchFrom.applicant" allowClear />
            </dc-form-item>
            <dc-form-item label="申请时间">
              <cos-range-picker
                v-model:startTime="searchFrom.applyStartTime"
                v-model:endTime="searchFrom.applyEndTime"
              />
            </dc-form-item>
            <dc-form-item name="tmsCode" label="客户代码">
              <a-input v-model:value="searchFrom.tmsCode" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="customerSerial" label="客户识别码">
              <a-input v-model:value="searchFrom.customerSerial" placeholder="请输入" />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAuditCoupon" v-permission="'lbu_batch_coupons_audit_btn'"
            >批量审核</a-button
          >
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'couponStatus'">
            <p> {{ couponStatusEnum.find((item) => item.value === text)?.label || '--' }}{{ record.couponFailedReason ? `(${record.couponFailedReason})` : '' }}</p>
          </template>
          <template v-if="column.dataIndex === 'reviewStatus'">
            <dc-status :enums="statusEnum" :value="text"/>
          </template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button
                type="link"
                :disabled="record.reviewStatus !== 1"
                @click="auditRow(record)"
                v-permission="'lbu_coupon_audit_btn'"
              >
                审核
              </a-button>
            </MoreButton>
          </template>
        </template>
      </cos-table>

      <AuditCouponModal ref="auditCouponRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import request from '@/utils/request'
import { AxiosPagination } from '@/typings/common'
import AuditCouponModal from './modal.vue'

const tableRef = ref()
const searchFrom = ref({ reviewStatus: 1 })
const selectedRows = ref<any[]>([])
const onSelectChange = (selectedRowKeys: string[], rows: any[]) => {
  selectedRows.value = rows
}

const success = () => {
  tableRef.value?.fetch()
}

const statusEnum = [
  { value: undefined, label: '全部' },
  { value: 1, label: '待审核', name: '待审核', color: '#1d4cd2' },
  { value: 2, label: '已通过', name: '已通过', color: '#3FAC46' },
  { value: 3, label: '已驳回', name: '已驳回', color: '#DF443B' }
]

const couponStatusEnum = [
  { value: 0, label: '失败' },
  { value: 1, label: '成功' }
]

const auditCouponRef = ref()
const handleAuditCoupon = () => {
  auditCouponRef.value.toggle(selectedRows.value)
}

const fetch = (searchFrom: any, callBack: (res: any) => void) => {
  const params = searchFrom // 处理客户名称和客户编码的批量查询参数
  request.post<AxiosPagination<any>>('/lbu/api/coupons/page', params).then((res) => {
    callBack(res)
  })
}

const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName', width: 200 },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户识别码', dataIndex: 'customerSerial' },
  { title: '申请人', dataIndex: 'applicantName' },
  { title: '申请时间', dataIndex: 'applyTime' },
  { title: '申请原因', dataIndex: 'reason' },
  { title: '审核人', dataIndex: 'reviewerName' },
  { title: '审核时间', dataIndex: 'reviewTime' },
  { title: '审核状态', dataIndex: 'reviewStatus' },
  { title: '审核意见', dataIndex: 'reviewComments' },
  { title: '营销活动', dataIndex: 'actName' },
  { title: '发券状态', dataIndex: 'couponStatus' },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])

const handleQueryChange = () => {
  tableRef.value?.search()
}

const auditRow = (row: any) => {
  auditCouponRef.value.toggle([row])
}
</script>
